
import { defineComponent } from 'vue';
import MainCardComponent from '../Cards/MainCardComp.vue';
import { mapGetters } from 'vuex';
import MainCardPreloadComponent from '../Cards/MainCardPreloadComp.vue';

export default defineComponent({
    name: 'MainCardsComponent',
        components: {
        MainCardComponent,
        MainCardPreloadComponent
    },
    computed: {
        ...mapGetters(["getPopularMods", "getCardsPreloaders"])
    }
})
